"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationFieldsContainer = void 0;
var core_1 = require("@material-ui/core");
var React = __importStar(require("react"));
var durationField_1 = require("./durationField");
var defaultLabelsEn_json_1 = __importDefault(require("./defaultLabelsEn.json"));
var utils_1 = require("./utils");
var DurationFieldsContainer = function (_a) {
    var _b = _a.views, views = _b === void 0 ? [] : _b, value = _a.value, setValue = _a.setValue, _labels = _a.labels, GridItemProps = _a.GridItemProps, GridContainerProps = _a.GridContainerProps, DurationFieldProps = _a.DurationFieldProps, _c = _a.DurationFieldComp, DurationFieldComp = _c === void 0 ? durationField_1.DurationField : _c;
    var labels = __assign(__assign({}, defaultLabelsEn_json_1.default), _labels);
    var duration = (0, utils_1.timeToDuration)(value, views);
    return (React.createElement(core_1.Grid, __assign({ container: true, spacing: 2, justify: 'space-around' }, GridContainerProps), views.map(function (view, i) { return (React.createElement(core_1.Grid, __assign({ key: i, item: true, xs: true }, GridItemProps),
        React.createElement(DurationFieldComp, __assign({ labels: labels, view: view, duration: duration, onConfirm: function (v) {
                var _a;
                setValue((0, utils_1.durationToTime)(__assign(__assign({}, duration), (_a = {}, _a[view] = v, _a))));
            } }, DurationFieldProps)))); })));
};
exports.DurationFieldsContainer = DurationFieldsContainer;
